import { render, staticRenderFns } from "./Fullscreen.vue?vue&type=template&id=13903ce7&scoped=true"
import script from "./Fullscreen.vue?vue&type=script&lang=js"
export * from "./Fullscreen.vue?vue&type=script&lang=js"
import style0 from "./Fullscreen.vue?vue&type=style&index=0&id=13903ce7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13903ce7",
  null
  
)

export default component.exports